import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-previous-exam',
  templateUrl: './previous-exam.component.html',
  styleUrls: ['./previous-exam.component.scss']
})
export class PreviousExamComponent implements OnInit {
  previousExam : FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    this.previousExam = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Debar: new FormControl(),
      Chng: new FormControl(),
    })
  }
  fetchList() {
    let payload = {}
    payload["SnNo"] = this.umsService.secretdata['SnNo'];
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMarks = res.data;
        this.filteredListOfMarks = this.ListOfMarks.slice();
      }
      else {

      }

    });

  }
}
